// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  adminBaseUrl:'https://api.gamodify.com/api/v1/admin/',
    // baseUrl : 'http://13.232.134.72:8070/api/v1/admin/',
// baseUrl:'https://api-edugamo.immodesta.com/api/v1/admin/'
baseUrl : 'https://api.gamodify.com/api/v1/admin/'
// baseUrl : 'https://api-gamodify.immodesta.com/api/v1/admin/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
